import { useEffect } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { POSTS } from "@/posts";

export const InsightPost = () => {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) return <Navigate to="/" replace />;

  return (
    <article className="py-20 sm:py-28" data-testid="insight-post-page">
      <div className="max-w-2xl mx-auto px-6">
        <Link
          to="/"
          data-testid="insight-back-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-violet-700 hover:text-violet-800 transition-colors duration-300"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to GrowRx
        </Link>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <p className="mt-10 text-xs font-semibold uppercase tracking-[0.2em] text-[#6B5CA5]">
            GrowRx Insights · {post.date} · {post.readTime}
          </p>
          <h1 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.12] text-[#3B0764]" data-testid="insight-post-title">
            {post.title}
          </h1>
          <div className="mt-10 space-y-6">
            {post.body.map((para, i) => (
              <p key={i} className="text-base sm:text-lg leading-relaxed text-[#4C1D95]/90">
                {para}
              </p>
            ))}
          </div>
          <div className="mt-12 rounded-3xl border border-violet-200 bg-violet-50 p-8 text-center">
            <p className="font-display text-xl font-bold tracking-tight text-[#3B0764]">
              Want this running for your firm?
            </p>
            <a
              href="/#book-audit"
              data-testid="insight-post-cta"
              className="group mt-5 inline-flex items-center gap-2 rounded-full bg-violet-700 px-7 py-3.5 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:bg-violet-800 hover:scale-[1.02]"
            >
              Book a Free Audit
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </motion.div>
      </div>
    </article>
  );
};
